(() => {
  const init = (scope) => {
    scope.querySelectorAll('[data-tc-print]').forEach((root) => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const data = JSON.parse(root.querySelector('[data-tc-print-data]').textContent);
      const text = JSON.parse(root.querySelector('[data-tc-print-strings]').textContent);
      const variants = JSON.parse(root.querySelector('[data-tc-variants]').textContent);
      const detail = root.querySelector('[data-tc-dimensions]');
      const button = root.querySelector('[data-tc-add]');
      if (!data || !variants.length) return;
      root.querySelector('[data-tc-title]').textContent = data.title;
      root.querySelector('[data-tc-region]').textContent = text.regionAU;
      const cm = (pair) => pair.map((x) => Number(x).toFixed(2)).join(' × ') + ' cm';
      const update = (input, changeUrl) => {
        const variant = variants.find((v) => String(v.id) === input.value);
        const spec = variant && data.sizes[variant.size];
        if (!spec) return;
        const formattedPrice = new Intl.NumberFormat(root.dataset.locale || 'en-AU', {style:'currency',currency:'AUD',currencyDisplay:'code'}).format(variant.price / 100);
        root.querySelectorAll('[data-tc-price]').forEach((price) => { price.textContent = formattedPrice; });
        button.disabled = !variant.available;
        button.textContent = variant.available ? text.add : text.soldOut;
        detail.replaceChildren();
        const b = spec.borderCm;
        const border = [b.left,b.right,b.top,b.bottom].map((x) => Number(x).toFixed(2)).join(' / ') + ' cm';
        [[text.paper,cm(spec.sheetCm)],[text.image,cm(spec.imageCm)],[text.frame,cm(spec.sheetCm)],[text.borders,border]].forEach(([heading,value]) => {
          const line = document.createElement('span');
          const strong = document.createElement('strong');
          strong.textContent = heading + ': ';
          line.append(strong,document.createTextNode(value));
          detail.append(line);
        });
        if (changeUrl) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant',variant.id);
          window.history.replaceState({},'',url);
        }
      };
      const inputs = root.querySelectorAll('input[name="id"]');
      inputs.forEach((input) => {
        const variant = variants.find((v) => String(v.id) === input.value);
        if (variant && data.sizes[variant.size]) input.nextElementSibling.textContent = data.sizes[variant.size].labelAU;
        input.addEventListener('change',() => update(input,true));
      });
      const checked = root.querySelector('input[name="id"]:checked');
      if (checked) update(checked,false);
      const quickBuy = root.querySelector('[data-tc-quick-buy]');
      const purchase = root.querySelector('[data-tc-purchase]');
      if (quickBuy && purchase && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver(([entry]) => { quickBuy.hidden = entry.isIntersecting; });
        observer.observe(purchase);
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => init(document)); else init(document);
  document.addEventListener('shopify:section:load',(event) => init(event.target));
})();

